module.exports = __webpack_public_path__ + "img/icon-social-media.25d81c03.svg";